var _radialGradient, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeviceMalfunction = function SvgDeviceMalfunction(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg18",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "4UU4ptC_mBgYTIFHxQVZab",
    cx: 18.189,
    cy: 16.781,
    r: 22.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop11",
    offset: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop13",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "#f9b808",
    d: "M44.634 37.846 25.76 7.787s-.508-1.05-1.76-1.05-1.76 1.05-1.76 1.05L3.366 37.846S3 38.337 3 39a2 2 0 0 0 2 2h38a2 2 0 0 0 2-2c0-.663-.366-1.154-.366-1.154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fill: "url(#4UU4ptC_mBgYTIFHxQVZab)",
    d: "M24.014 37q-1.098 0-1.812-.666c-.714-.666-.714-.981-.714-1.613q0-.989.721-1.62.72-.631 1.805-.631 1.099 0 1.798.638.7.639.7 1.613 0 .988-.693 1.633c-.693.645-1.064.646-1.805.646m2.222-19.279-.481 12.175a.694.694 0 0 1-.693.666h-2.179a.694.694 0 0 1-.693-.668l-.455-12.174a.694.694 0 0 1 .693-.72h3.116c.393 0 .708.327.692.721"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceMalfunction);
export default ForwardRef;